import { render, staticRenderFns } from "./AssetSidebar.vue?vue&type=template&id=4d792158&scoped=true&"
import script from "./AssetSidebar.vue?vue&type=script&lang=js&"
export * from "./AssetSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AssetSidebar.vue?vue&type=style&index=0&id=4d792158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d792158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d792158')) {
      api.createRecord('4d792158', component.options)
    } else {
      api.reload('4d792158', component.options)
    }
    module.hot.accept("./AssetSidebar.vue?vue&type=template&id=4d792158&scoped=true&", function () {
      api.rerender('4d792158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AssetTracking/AssetSidebar.vue"
export default component.exports